module.exports = __webpack_public_path__ + "static/media/copy-blue.c9e98166.svg";